module.exports = __webpack_public_path__ + "img/tm6.da729ba9.png";